import React, { useEffect, useState } from 'react'
import { Helmet } from 'react-helmet'
import therapy from '../../assets/img/therapy/therapy_bg.png'
import { Text } from '../../components/Text'
import FooterSection from '../Footer'
import ConnectUs from '../../components/ConnectUs'
import Header from '../Header'
import time from '../../assets/img/icon/all-white.png'
import t_1 from '../../assets/img/therapy/t_1.png'
import t_2 from '../../assets/img/therapy/t_2.png'
import t_3 from '../../assets/img/therapy/t_3.png'
import t_4 from '../../assets/img/therapy/t_4.png'
import t_5 from '../../assets/img/therapy/t_6.png'
import bg from '../../assets/img/therapy/bg-therapy.png'
import QASectionSub from '../../components/sections/QASectionSub'
import { InfoSection } from '../../components/InfoSection'
import TherapyCard from '../../components/TherapyCard'
import { services } from '../../assets/dummy'
import ServiceModal from '../../components/ServiceCardModal'
import carepay from '../../assets/img/carepay/carepay_bg.png'
import android from '../../assets/img/carepay/android.png'
import apple from '../../assets/img/carepay/apple.png'
import logo from '../../assets/img/carepay/carepay_logo.png'
import intro from '../../assets/img/therapy/therapy_banner.jpg'
import DownloadSection from '../../components/DownloadSection'

export default function Therapy () {
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [selectedService, setSelectedService] = useState(null)
  const [isScrolled, setIsScrolled] = useState(false)

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50) 
    }

    window.addEventListener('scroll', handleScroll)
    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [])
  const filteredServices = services.filter(
    service => service.tag === 'Эсийн эмчилгээ'
  )
  const callModal = service => {
    setSelectedService(service.content)
    setIsModalOpen(true)
  }

  const closeModal = () => {
    setIsModalOpen(false)
    setSelectedService(null)
  }
  return (
    <>
      <Helmet>
        <title>CellClinic - Эсийн эмчилгээ</title>
        <meta
          name='description'
          content='Хүний биеийн бүтэц, үйл ажиллагааны үндсэн нэгж болох эс нь
                байгалиас заяасан орлуулшгүй үнэтэй эмчилгээний эх үүсвэр юм.
                Эсийн эмчилгээ нь хавдар, аутоиммун өвчин, эрхтэн шилжүүлэн
                суулгалтын дараах дархлаа зохицуулалт, хөгшрөлтийн эсрэг
                үйлчилгээ, шархны эдгэрэлтийг хурдасгах болон нөхөн сэргээх
                анагаах ухааны гол түлхүүр болж байна.'
        />
      </Helmet>
      <div
        className='bg-gradient-to-l from-[#81E9AE] to-[#0C341E] bg-cover bg-center bg-no-repeat h-[100vh] '
        style={{
          backgroundImage: `url(${therapy})`,
          mixBlendMode: 'luminosity'
        }}
      >
        <div
          className={`fixed top-0 left-1/2 transform -translate-x-1/2 w-full  z-50 transition-all duration-300 ${
            isScrolled
              ? 'bg-blue shadow-md h-[7vh] top-1 max-w-[1440px] extraScreen:max-w-[1500px]'
              : 'bg-transparent h-[5vh]'
          }`}
        >
          <Header
            color={isScrolled ? 'black' : 'white'}
            gradientColor={isScrolled ? 'bg-white/90' : 'bg-none'}
          />
        </div>
        {/* <Header
          color='white'
          // gradientColor='bg-gradient-to-l from-[#81E9AE] to-[#0C341E]'
        /> */}
        <div className='h-[90vh] flex flex-col  maxScreen:max-w-[1440px]  extraScreen:max-w-[1660px] maxScreen:mx-auto extraScreen:mx-auto '>
          <div
            className='flex-1 flex flex-row items-center justify-center gap-5 p-20 
          mobile:gap-0 mobile:p-8 mobile:flex-col tablet:flex-col tablet:py-2 tablet:px-5'
          >
            <div className='w-1/2 mobile:w-full tablet:w-full tablet:flex tablet:flex-col tablet:items-center tablet:justify-center mobile:mt-[140px]'>
              <button
                className='backdrop-blur-xl bg-white/10 py-1.5 px-5 text-white rounded-xl mt-5 
            flex items-center justify-center gap-2 cursor-pointer text-xs mobile:mb-4 tablet:mb-4 mobile:hidden'
              >
                <img src={time} alt='ds' className='w-6 h-6' />
                Эсийн эмчилгээ
              </button>
              <p className='text-[36px] font-extrabold mobile:text-[32px] text-white mt-4'>
                Эсээр эмчилнэ
              </p>
              <Text className='text-white/75 mt-5 max-w-[450px] mobile:text-justify text-[16px] mobile:mb-4 tablet:max-w-full tablet:mb-4 tablet:text-center mobile:bg-black/40 mobile:p-5 mobile:rounded-xl'>
                Хүний биеийн бүтэц, үйл ажиллагааны үндсэн нэгж болох эс нь
                байгалиас заяасан орлуулшгүй үнэтэй эмчилгээний эх үүсвэр юм.
                Эсийн эмчилгээ нь хавдар, аутоиммун өвчин, эрхтэн шилжүүлэн
                суулгалтын дараах дархлаа зохицуулалт, хөгшрөлтийн эсрэг
                үйлчилгээ, шархны эдгэрэлтийг хурдасгах болон нөхөн сэргээх
                анагаах ухааны гол түлхүүр болж байна.
              </Text>
            </div>

            <div className='w-1/2  mobile:w-full mobile:mt-20 tablet:w-[400px]'>
              {/* <div
                className='relative self-center bg-cover bg-center rounded-3xl h-[492px] mobile:h-[300px] tablet:h-[300px]'
                style={{ backgroundImage: `url(${therapy})` }}
              /> */}
            </div>
          </div>
        </div>
      </div>
      <div className='maxScreen:max-w-[1440px] px-20 tablet:px-5 mobile:px-5 extraScreen:max-w-[1660px] maxScreen:mx-auto extraScreen:mx-auto extraScreen:px-20 maxScreen:px-20'>
        <div className='flex flex-col justify-center items-start py-20   mobile:rounded-[24px] mobile:p-5 tablet:p-5'>
          <div className=' bg-green-100 p-10 mobile:p-5 rounded-2xl'>
            <button
              className='text-[#478C47] border-l-2 border-[#5EBC5E] text-[26px] px-5 font-bold text-start 
            bg-gradient-to-l from-[#FFFFFF1F] to-[#5EBC5E1F]
          mobile:text-[24px] mobile:w-full tablet:w-full tablet:text-[24px] tablet:mb-5'
            >
              Эсийн эмчилгээ нь ирээдүйн анагаах ухааны гол чиглэл болж,
              эмчилгээгүй өвчнүүдийг эмчлэх шинэ боломжийг нээж байна.
            </button>
            <InfoSection
              title='Эсийн эмчилгээ гэж юу вэ?'
              text='Эсийн эмчилгээ нь өвчин эмгэгийг эмчлэх, гэмтсэн эдийг нөхөн
              сэргээх зорилгоор хүний эсийг ашиглах дэвшилтэт анагаах ухааны
              арга юм. Энэ нь ихэвчлэн хүний биеэс эсүүдийг тусгайлан ялгаж,
              зарим тохиолдолд өсгөж, боловсруулсны дараа эргүүлэн бие рүү
              оруулах эсвэл гэмтэлтэй хэсэгт хэрэглэхийг хэлнэ. Эсийн
              эмчилгээний гол зорилго нь гэмтсэн эс, эдийг нөхөн сэргээж, биеийн
              байгалийн эдгэрэлтийг дэмжих юм.'
              imgSrc={t_1}
            />
            <InfoSection
              title='Нөхөн сэргээх эсийн эмчилгээ'
              text='Нөхөн сэргээх эсийн эмчилгээ нь хүний өөрийн эсийг ашиглан гэмтсэн
              эдийг нөхөн сэргээх орчин үеийн арга юм. Энэ эмчилгээ нь
              түлэгдэлт, шарх, үений мөгөөрсний гэмтэл зэрэгт үр дүнтэй. Тухайн
              эсүүдийг тусгай аргаар боловсруулж, гэмтсэн хэсэгт тарьснаар эд
              эсийн нөхөн төлжилтийг түргэсгэж, байгалийн эдгэрэлтийн явцыг
              дэмждэг. Нөхөн сэргээх эсийн эмчилгээ нь өвчтөнд аюулгүй, үр дүн
              сайтайгаар эд эсийг сэргээх боломжийг олгодог.'
              imgSrc={t_2}
              reverse
            />
            <button
              className='text-[#478C47] border-l-2 border-[#5EBC5E] px-5 text-[26px] font-inter-bold mb-5 mt-5
             bg-gradient-to-l from-[#FFFFFF1F] to-[#72C5B91F]
            text-start 
          mobile:text-[24px] mobile:w-full tablet:w-full tablet:text-[30px] tablet:mb-4'
            >
              Үүдэл эс бол бүхнийг эхлүүлэгч ундарга юм, тэд биеийн аль ч эсэд
              хувирч эмчлэх, нөхөн сэргээх хүчийг агуулдаг - Шинья Яманака
              (Нобелийн шагналт)
            </button>
            <InfoSection
              title='Үүдэл эсийн эмчилгээ'
              text='Үүдэл эсийн эмчилгээ нь нөхөн сэргээх анагаах ухаанд хамгийн өргөн
              ашиглагддаг. Үүдэл эсийн нөхөн төлжүүлэх, ялгаран хөгжих, өөрийгөө
              хувилах чадварыг ашиглан цусны хорт хавдар, зүрх судасны өвчин,
              мэдрэлийн эмгэг, элэгний цочмог дутагдал, нойр булчирхайн үрэвсэл
              зэрэг олон төрлийн өвчин эмгэгийг эмчлэхэд ашиглагддаг. Мөн
              түлэгдэлт, шархны эдгэрэлт, үсний ургалт, арьсны хөгшрөлтийг удаашруулах
              зэрэг гоо сайхны зорилгоор хэрэглэгдэнэ. Орчин үед үүдэл эсийг
              хөгшрөлтийг удаашруулах зорилгоор мөн хэрэглэдэг. Үүдэл эс нь
              гэмтсэн эдийг нөхөн сэргээж, байгалийн эдгэрэлтийг дэмждэг тул
              аюулгүй, үр дүнтэй эмчилгээний шинэ аргачлал юм.'
              imgSrc={t_3}
            />
            <InfoSection
              title='Дархлааны эсийн эмчилгээ'
              text='Дархлааны эсийн эмчилгээ нь хорт хавдар, эрхтэн шилжүүлэн
              суулгалт, аутоиммун эмгэг зэрэг олон төрлийн өвчнийг эмчлэхэд
              дархлааны эсийг зорилтот байдлаар ашигладаг дэвшилтэт технологи
              юм. Энэ эмчилгээ нь өвчтөний өөрийн дархлааны эсүүдийг
              идэвхжүүлэх, эсвэл лабораторийн нөхцөлд боловсруулж, өвчинтэй илүү
              үр дүнтэй тэмцэх чадвартай болгоход чиглэгддэг.'
              imgSrc={t_4}
              reverse
            />
            <button
              className='text-[#478C47] border-l-2 border-[#5EBC5E] px-5 text-[26px] font-inter-bold mb-5 mt-5
             bg-gradient-to-l from-[#FFFFFF1F] to-[#72C5B91F]
            text-start 
          mobile:text-[24px] mobile:w-full tablet:w-full tablet:text-[30px] tablet:mb-4'
            >
              Монгол улсад одоогоор гоо сайхны зорилгоор арьсны амьд эсийг
              ашиглаж эхлээгүй байна. ERP, SkinCell, HairCell, SkinSpray нь
              үйлчлүүлэгчийн өөрийнх нь арьсны эсийг ашигладаг.
            </button>
            <InfoSection
              title='Гоо сайхны эмчилгээ'
              text='Эсийн эмчилгээ нь гоо сайхны салбарт арьсыг залуужуулах, гэмтсэн
              эдийг нөхөн сэргээх, үс ургалтыг идэвхжүүлэх зэрэг олон төрлийн
              асуудлыг шийдвэрлэхэд ашиглагдаж буй дэвшилтэт арга юм. Энэ нь
              хүний өөрийн эсийг ашиглан байгалийн гоо үзэсгэлэнг сэргээх, насны
              өөрчлөлттэй тэмцэх, арьс болон үсний эрүүл мэндийг дэмжихэд
              чиглэгддэг.'
              imgSrc={t_5}
            />
          </div>
        </div>
        <div className='relative z-10'>
          <DownloadSection
          image={intro}
          pdfLink='/pdf/CellClinic_CellTherapy.pdf'
          gradient='linear-gradient(270deg, #81E9AE 0%, #0C341E 40%)'
          subjectPassed='Эсийн эмчилгээний танилцуулга'
          text1='Анагаахын шинжлэх ухааны гайхамшигт ололт, дэвшилтэт технологийг сонирхож буй танд баяр хүргэе! 🎉'
          text2='Манай клиник Монгол Улсад анхлан үйлчлүүлэгчийн өөрийн амьд эсийг боловсруулан эмчилгээнд ашиглаж буй дэвшилтэт аргачлалыг нэвтрүүлэн ажиллаж байна. Энэ нь биеийн нөхөн төлжих чадварыг дэмжих, эрүүл мэндийг сэргээх шинэ боломжийг бий болгож байна.'
          text3=''
          attachText='Танд зориулсан үйлчилгээний дэлгэрэнгүй танилцуулгыг доорх холбоосоор татаж авна уу.'
          bonus='Хэрэв танд нэмэлт мэдээлэл хэрэгтэй бол бидэнд хэзээд хандаарай!'
          ccEmail='therapy@cellclinic.mn'
        ></DownloadSection>
        </div>
        <div
          className='h-full tulbur-screen mt-20 px-20 flex flex-col items-center justify-center rounded-xl mobile:mt-16 mobile:mb-5 mobile:max-w-full  mobile:p-5 maxScreen:p-0 extraScreen:p-0  maxScreen:max-w-[1440px]  extraScreen:max-w-[1660px] maxScreen:mx-auto extraScreen:mx-auto cursor-pointer'
          onClick={() => window.open('https://carepay.mn/')}
        >
          <main className='flex flex-col justify-center'>
            <div
              className='bg-cover bg-center bg-no-repeat flex flex-row justify-between items-center py-5 px-5 rounded-2xl mobile:flex-col mobile:justify-center mobile:items-center '
              style={{
                backgroundImage: `url(${carepay})`,
                mixBlendMode: 'luminosity'
              }}
            >
              <div className='h-20 w-1/5 mobile:w-full ml-5 mobile:ml-40'>
                <img
                  className='cursor-pointer h-[40px] mt-4'
                  src={logo}
                  alt='logo'
                ></img>
              </div>
              <div className='text-white w-4/5 px-20 text-center text-[24px]  mobile:text-[20px] mobile:mb-2 mobile:px-0 mobile:w-full'>
                Хүү, шимтгэлгүй хуваан төлөх онцгой нөхцөл
              </div>
              <div className='w-[160px] mobile:w-full cursor-pointer mobile:flex  mobile:items-center mobile:flex-col flex justify-end flex-col '>
                <img
                  className=' mobile:h-[40px]'
                  src={android}
                  alt='dd'
                  onClick={() =>
                    window.open(
                      'https://play.google.com/store/apps/details?id=com.bitsoft.carepay'
                    )
                  }
                ></img>
                <img
                  src={apple}
                  alt='ff'
                  className='mt-2 cursor-pointer  mobile:h-[40px]'
                  onClick={() =>
                    window.open(
                      'https://apps.apple.com/mn/app/carepay/id6446045879'
                    )
                  }
                ></img>
              </div>
            </div>
          </main>
        </div>
        <div
          className='h-[100vh] therapy-screen mobile:px-5 mobile:py-5 mobile:h-full tablet:h-full  
      maxScreen:max-w-[1440px]  extraScreen:max-w-[1660px] extraScreen:mt-[-100px] extraScreen:mb-[-100px] flex  flex-col justify-center '
        >
          <div
            className='py-10 flex flex-col items-center justify-center rounded-3xl bg-cover bg-center bg-no-repeat
          mobile:py-5 mobile:mt-10 
          tablet:p-5 tablet:mt-10 
'
            style={{
              backgroundImage: `url(${bg})`,
              backgroundRepeat: 'no-repeat'
            }}
          >
            <main className='container mx-auto flex justify-center'>
              <div>
                <p className='text-[30px] text-center text-white font-inter-bold mobile:text-[24px] mobile:font-bold tablet:text-[28px] uppercase '>
                  Санал болгож буй аутологи буюу амьд эсээс гаргаж авсан эсийн
                  эмчилгээнүүд
                </p>
                {/* <Text className='mt-5  text-center text-white mobile:mx-3 text-[14px] uppercase'>
                  аутологи буюу хүний өөрийн амьд эсээс гаргаж авсан эсийн
                  эмчилгээнүүд
                </Text> */}
              </div>
            </main>
            <div
              className='grid grid-cols-4 gap-5 py-5 
            mobile:grid-cols-1 mobile:px-5 mobile:gap-4 mobile:w-full mobile:py-0
            tablet:grid-cols-2 tablet:px-5
            extraScreen:gap-8 maxScreen:px-[140px] maxScreen:gap-8 '
            >
              {filteredServices.map(item => (
                <div className='mobile:group '>
                  <TherapyCard data={item} callModal={callModal}></TherapyCard>
                </div>
              ))}
              {isModalOpen && (
                <ServiceModal
                  selectedService={selectedService}
                  closeModal={closeModal}
                />
              )}
            </div>
          </div>
        </div>

        <div
          className='mb-20 mobile:px-5 mobile:py-5  mobile:mt-16 mobile:mb-5 tablet:ml-5  tablet:px-5 tablet:mb-5 tablet:mt-5
      maxScreen:max-w-[1440px]  extraScreen:max-w-[1660px] maxScreen:mx-auto extraScreen:mx-auto'
        >
          <QASectionSub
            tags={[
              { name: 'ERP', category: 'ERP' },
              { name: 'SkinCell', category: 'SkinCell' },
              { name: 'SprayCell', category: 'SprayCell' },
              { name: 'HairCell', category: 'HairCell' }
            ]}
            category='Эсийн эмчилгээ'
            textColor='#478C47'
            bgColor='green-100'
          />
        </div>
        {/* contact us section */}
        <div className='mobile:px-5 tablet:px-5 maxScreen:max-w-[1440px]  extraScreen:max-w-[1660px] maxScreen:mx-auto extraScreen:mx-auto maxScreen:px-0 extraScreen:px-0'>
          <ConnectUs
            bgImage='greenLight'
            gradientColor='bg-gradient-to-l from-[#81E9AE] to-[#0C341E] '
          ></ConnectUs>
        </div>
        {/* footer section */}
        <div className='py-10 mobile:px-5  mobile:mb-5 mobile:py-0 tablet:px-5  tablet:mb-5 maxScreen:max-w-[1440px]  extraScreen:max-w-[1660px] maxScreen:mx-auto extraScreen:mx-auto maxScreen:px-0 extraScreen:px-0'>
          <FooterSection></FooterSection>
        </div>
      </div>
    </>
  )
}
